import { configureStore } from "@reduxjs/toolkit";
import fetchJobsReducer from "../features/jobs/jobsSlice";
import fetchJobReducer from "../features/job/fetchJobSlice";
import filterReducer from "../features/filters/filterSlice";

export const store = configureStore({
  reducer: {
    jobs: fetchJobsReducer,
    editJob: fetchJobReducer,
    filters: filterReducer,
  },
});
